import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { DashboardService } from '../dashboard.service';

@Component({
    selector: 'app-single-news',
    templateUrl: './single-news.component.html',
    styleUrls: ['./single-news.component.css'],
    standalone: false
})
export class SingleNewsComponent implements OnInit {
  articleId: string = '';
  environment = environment;
  article: any = {};
  constructor(private route: ActivatedRoute, private dashboardService: DashboardService) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => this.articleId = params["id"]);
    this.getSingleArticle();
  }

  getSingleArticle(): void {
    this.dashboardService.getSingleArticle(this.articleId).subscribe((data) => {
      this.article = data[0];
    });
  }

}
